module.exports = __webpack_public_path__ + "static/media/icon_11.dd8f96a5.svg";